import api from "../api/api";

// export const login = async (
//   username: string,
//   password: string
// ): Promise<string> => {
//   try {
//     const response = await api.post("/zhadiger/api/auth/login", {
//       username,
//       password,
//     });

//     const token = response.data; // API returns token as a string (no object)
//     console.log("Extracted Token:", token); // Debugging

//     if (!token || !token.startsWith("Bearer ")) {
//       throw new Error("Invalid token format received");
//     }

//     return token; // Do NOT store it here; let `AuthContext` handle that
//   } catch (error) {
//     console.error("Login failed:", error);
//     throw error;
//   }
// };

export const register = async (
  username: string,
  password: string,
  passwordConfirm: string,
  email: string,
  phoneNumber: string
): Promise<string> => {
  try {
    const response = await api.post("/zhadiger/api/auth/register", {
      username,
      password,
      passwordConfirm,
      email,
      phoneNumber,
    });
    const token = response.data.token;
    localStorage.setItem("token", token);
    return token;
  } catch (error) {
    console.error("Registration failed:", error);
    throw error;
  }
};

export const logout = (): void => {
  try {
    localStorage.removeItem("token");
    console.log("Logged out successfully");
  } catch (error) {
    console.error("Logout failed:", error);
    throw error;
  }
};
